/**
 * 情绪文案选择器
 */
import type { NarrativeLibrary, SchoolName } from './types'

/**
 * 优先返回 specific 命中的文案；否则回退到 school_global
 */
export function pickNarrative(
  school: SchoolName,
  rank: number,
  library: NarrativeLibrary
): string | null {
  const hit = library.specific.find(
    (item) => item.school === school && rank >= item.rank_min && rank <= item.rank_max
  )
  if (hit) return hit.text
  return library.school_global[school] ?? null
}
